var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center sidebar-minimizer",on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"angle-left"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }